import {
    PROCESS_PROCESSOR_REQUEST,
    PROCESS_PROCESSOR_SUCCESS,
    PROCESS_PROCESSOR_FAILURE,
} from "../actions/processorAction";

const RESET_PROCESSOR_DATA = "RESET_PROCESSOR_DATA"; // New action type

const initialState = {
    processing: false,
    processorData: null,
    error: null,
};

const processorReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROCESS_PROCESSOR_REQUEST:
            return {
                ...state,
                processing: true,
                error: null,
            };

        case PROCESS_PROCESSOR_SUCCESS:
            return {
                ...state,
                processing: false,
                processorData: action.payload,
                error: null,
            };

        case PROCESS_PROCESSOR_FAILURE:
            return {
                ...state,
                processing: false,
                processorData: null,
                error: action.payload,
            };

        case RESET_PROCESSOR_DATA: // Handle reset action
            return initialState;

        default:
            return state;
    }
};

export default processorReducer;
